import React from 'react';
import type {Item} from '../../../../../../../types/app.types';
import {useLocaleKeys} from '../../../../../LocaleKeysProvider';
import type {LocaleKeys} from '../../../../../../../locale-keys/LocaleKeys';
import {getTranslatedString} from './getTranslatedString';
import {ModifiersDataHook} from './Modifiers';

type Modifier = NonNullable<NonNullable<NonNullable<Item['modifierGroups']>[number]>['modifiers']>[number];

export function ModifierDetails({modifier}: {modifier: Modifier}) {
  const lk = useLocaleKeys();
  return <li data-hook={ModifiersDataHook.ModifierLine}>{translatedModifierDetails(modifier, lk)}</li>;
}

function translatedModifierDetails(modifier: Modifier, lk: LocaleKeys): string {
  if (modifier.quantity && modifier.price) {
    return lk.thankYouPage.modifiers.modifierDetails.quantityAndPrice({
      quantity: modifier.quantity,
      modifierName: getTranslatedString(modifier?.label),
      price: modifier.price.formattedAmount,
    });
  }

  if (modifier.quantity) {
    return lk.thankYouPage.modifiers.modifierDetails.quantity({
      quantity: modifier.quantity,
      modifierName: getTranslatedString(modifier?.label),
    });
  }

  if (modifier.price) {
    return lk.thankYouPage.modifiers.modifierDetails.price({
      modifierName: getTranslatedString(modifier?.label),
      price: modifier.price.formattedAmount,
    });
  }

  return lk.thankYouPage.modifiers.modifierDetails.other({
    modifierName: getTranslatedString(modifier?.label),
  });
}
